import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import WarningModal from 'shared/lib/components/modals/warningModal';
import { useTranslation } from 'react-i18next';
import { ModalProps } from 'shared/lib/components/modals/modal';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { foldersApi } from 'entities/folder/api/foldersApi';

export type DeleteFolderModalControllerActions = {
  afterFolderDelete?: (id: string) => void;
};

export default observer(function DeleteFolderModalController({
  id,
  afterFolderDelete,
  handleClose,
}: {
  id: string;
} & DeleteFolderModalControllerActions & {
    handleClose: ModalProps['handleClose'];
  }) {
  const { mobxStore } = useContext(MobxContext);
  const { t } = useTranslation();

  return (
    <>
      <WarningModal
        mainText={t('warnings.delete.folderMain')}
        secondText={t('warnings.delete.folderSecond')}
        isOpen={true}
        onCancel={handleClose}
        onContinue={async () => {
          try {
            await foldersApi.delete(id);
            afterFolderDelete && afterFolderDelete(id);
          } catch (e) {
            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
            console.error(e);
          }
          handleClose();
        }}
      ></WarningModal>
    </>
  );
});
